import * as Factory from 'factory.ts'
import faker from 'faker'

import {
  Currency,
  type CurrencyConstructor,
} from '@webapp/core/entities/external/Currency'
import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'

export const CurrencyConstructorFactory =
  Factory.Sync.makeFactory<CurrencyConstructor>({
    id: Factory.each(() => faker.random.number()),
    name: 'CAD',
    rate: 1,
    base: false,
  })

export const CurrencyFactory = EntityFactory(
  Currency,
  CurrencyConstructorFactory
)
